import "./RequestQuotation.module.css";
import Header from "@/reusable_sections/Header";
import QuotationRequestForm from "./sections/QuotationRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function RequestQuotationPage() {
  return <div>
      <Header />
      <QuotationRequestForm />
      <Footer />
    </div>;
}